'use strict';


module.exports = function (client) {

    client.disco.addFeature('jid\\20escaping');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/escaping.js
// module id = 579
// module chunks = 2